import React from 'react';
import VasekBuchtaPage from './VasekBuchtaPage';
import './App.css';

function App() {
  return <VasekBuchtaPage />;
}

export default App;
